import { DataStoreValue } from './DataStorePaneStateUtility';
import { DataStorePaths } from './DataStorePaths';
import { buildEnteringToIndices, interpolatePathWithMapping, PaneInterpolation, PaneInterpolationContext } from './PaneInterpolation';
import { PaneStateAttributeUtil } from './PaneStateAttribute';

export class MapPaneInterpolation implements PaneInterpolation {
  interpolatePane(
    context: PaneInterpolationContext,
    paneId: string,
    targetGetValue: (path: string) => DataStoreValue,
    fraction: number,
    exitingToIndices?: Set<number>
  ): void {
    const markIdPath = `PDMarks.${paneId}.Encodings.MarkId`;
    const fromMarkIds = context.getValue(markIdPath);
    const toMarkIds = targetGetValue(markIdPath);
    const indexMapping = context.buildMarkIdIndexMapping(fromMarkIds, toMarkIds);
    const enteringToIndices = buildEnteringToIndices(toMarkIds, indexMapping);

    for (const attribute of PaneStateAttributeUtil.getMapAllowedMarkAttributes()) {
      const path = DataStorePaths.getKeyPathForAttribute(paneId, attribute);
      if (!path) {
        continue;
      }
      interpolatePathWithMapping(context, targetGetValue, path, attribute, fraction, indexMapping, enteringToIndices, exitingToIndices);
    }
  }
}
